//CSS
import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/animate.css';
import './assets/css/vendor/font-awesome.min.css';
import './assets/js/vendor/animsition/css/animsition.min.css';
import './assets/css/main.css';

// Javascript
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { persistStore } from 'redux-persist';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

export default class Preloader extends React.Component {
    constructor() {
        super();
        this.state = { rehydrated: false }
    }

    componentWillMount() {
        persistStore(store, {}, () => { this.setState({ rehydrated: true }); });
    }

    render() {
        if (!this.state.rehydrated) {
            return (<p>Boot no sistema...</p>);
        }
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </Provider>
        );
    }
}

ReactDOM.render(<Preloader />, rootElement);

registerServiceWorker();
